module.exports = __webpack_public_path__ + "static/media/HCMM041.5df73f17.jpg";